<div class="banners-container">

  <div class="banners">

    <div *ngFor="let banner of banners" class="banner">
      <a *ngIf="banner.url!==BNN_TIRANT_ONLINE && banner.url!==BNN_BIBLIOTECA" [href]="banner.url" target="_blank"
        [title]="banner.title">
        <img [src]="banner.files[0].url" loading="lazy">
      </a>
      <button *ngIf="banner.url===BNN_TIRANT_ONLINE || banner.url===BNN_BIBLIOTECA" (click)="handleToBanner(banner.url)"
        [title]="banner.title">
        <img [src]="banner.files[0].url" loading="lazy">
      </button>
    </div>

  </div>

</div>